import Navbar from "../components/Navbar";
import space from "../assets/Initiatives/tasbih3new.jpeg";
import "../css/home.css";
// import Initiatives from "../components/Initiatives";
import Footer from "../components/Footer";
import ContactForm from "../components/ContactForm";
import Landing from "../components/Landing";
import Funds from "../components/Funds";
import Review from "../pages/Review";
import BackToTop from "../components/BackToTop";
import ThemeApplier from "../components/ThemeApplier";
import SecondLanding from "../components/SecondLanding";

export default function Home() {
  return (
    <>
      <Navbar />
      <div className="video-container">
        {/* <video src={space} type="video/mp4" autoPlay loop muted> */}
        {/* Sorry, your browser doesn't support videos. */}
        {/* </video> */}
        <img src={space} alt="Image" />
        {/* <div className="typewriter">
                    <h2>Al Qaim Welfare Foundation... </h2>
                </div> */}
      </div>
      <ThemeApplier />
      <Landing />
      <SecondLanding />
      {/* <Initiatives /> */}
      <Funds />
      {/* <Review /> */}
      <ContactForm />
      <Footer />
      <BackToTop />
    </>
  );
}
